import React, { useEffect, useState } from "react";
import productimg from "../../images/Icons/products.png";
import placeImage from "../../images/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import useLogout from "../Auth/useLogout";
import { fetchCommodityProduct } from "../../redux/slice/commodityProduct";
import NumberFormatter from "../../Component/NumberFormatter";
import { fetchCategory } from "../../redux/slice/category";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import Swal from 'sweetalert2';
import { hasPermission, canAccessRoute } from "../../utils/permissionUtils";
import { useNavigate } from "react-router-dom";

export default function CommodityProduct() {
  const navigate = useNavigate();
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  // Check if user has permission to access this page
  useEffect(() => {
    if (!canAccessRoute('commodity-products')) {
      navigate('/');
      toast.error('You do not have permission to access this page', {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [navigate]);

  //Product List
  const dispatch = useDispatch();
  const logout = useLogout();
  const { commodityProductData, isError } = useSelector(
    (state) => state.commodityProduct
  );
  const [dataLoading, setDataLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (!isError) {
        setDataLoading(true);
        try {
          await dispatch(fetchCommodityProduct(logout));
        } catch (error) {
        } finally {
          setDataLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError, logout]);

  //Product Data
  const [productList, setProductList] = useState([]);
  const [productDetail, setProductDetail] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState({
    category: "",
    product: "",
    brand: "",
    state: "",
    city: "",
  });
  const [formError, setFormError] = useState({
    categoryError: "",
    productError: "",
    brandError: "",
    stateError: "",
    cityError: "",
  });
  const { categoryData, isError1 = isError } = useSelector(
    (state) => state.category
  );
  useEffect(() => {
    if (!isError1) {
      dispatch(fetchCategory());
    }
  }, [dispatch, isError1]);
  const categoryChange = async (event) => {
    const category = event.target.value;

    if (category) {
      try {
        const response = await axios.get(
          `${config.apiUrl}/seller/commodity-product-list`,
          {
            params: { category_id: category },
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );
        setProductList(response.data.products_list);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      }
    }
    setProductData({
      ...productData,
      category: category,
    });
  };
  const productChange = async (event) => {
    const product = event.target.value;

    if (product) {
      try {
        const response = await axios.get(`${config.apiUrl}/seller/get-brand`, {
          params: { commodity_product_id: product },
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        });

        setBrandList(response.data.brand_list);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      }
    }
    setProductData({
      ...productData,
      product: product,
    });
  };
  const brandChange = async (event) => {
    const brand = event.target.value;
    const product = productData.product;

    if (brand && product) {
      try {
        const response = await axios.get(`${config.apiUrl}/seller/get-state`, {
          params: { commodity_product_id: product, brand_id: brand },
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        });

        setStateList(response.data.state_list);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      }
    }

    setProductData({
      ...productData,
      brand: brand,
    });
  };
  const stateChange = async (event) => {
    const state = event.target.value;
    const product = productData.product;
    const brand = productData.brand;

    if (state && brand && product) {
      try {
        const response = await axios.get(`${config.apiUrl}/seller/get-city`, {
          params: {
            commodity_product_id: product,
            brand_id: brand,
            state: state,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        });
        setCityList(response.data.city_list);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      }
    }

    setProductData({
      ...productData,
      state: state,
    });
  };
  const cityChange = (event) => {
    const city = event.target.value;

    setProductData({
      ...productData,
      city: city,
    });
  };
  const validateForm = () => {
    const newErrors = {};

    if (!productData.category) {
      newErrors.categoryError = "Please select a category";
    }
    if (!productData.product) {
      newErrors.productError = "Please select a product";
    }
    if (!productData.brand) {
      newErrors.brandError = "Please select a brand";
    }
    if (!productData.state) {
      newErrors.stateError = "Please select a state";
    }
    if (!productData.city) {
      newErrors.cityError = "Please select a city";
    }
    setFormError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const submitProduct = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/seller/store-commodity-product`,
          {
            product_id: productData.product,
            brand_id: productData.brand,
            state: productData.state,
            city: productData.city,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          resetData();
          setMode("list");
          dispatch(fetchCommodityProduct());
        }, [1500]);
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    }
  };
  const resetData = () => {
    setProductList([]);
    setBrandList([]);
    setStateList([]);
    setCityList([]);
    setProductData({
      category: "",
      product: "",
      brand: "",
      state: "",
      city: "",
    });
    setFormError({
      categoryError: "",
      productError: "",
      brandError: "",
      stateError: "",
      cityError: "",
    });
    setProductDetail([]);
  };
  const [selectedImage, setSelectedImage] = useState(placeImage);
  const handleImageClick = (imgSrc) => {
    setSelectedImage(imgSrc);
  };
  const [mode, setMode] = useState("list");
  const handleMode = (mode_type, product = null) => {
    setMode(mode_type);
    resetData();
    if (mode_type === "show" && product !== null) {
      setProductDetail(product);
      setSelectedImage(product.thumbnail);
    }
  };

  //Product Price Variation Stock
  const [updateMode, setUpdateMode] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const [productNameId, setproductNameId] = useState({
    product_id: "",
    product_name: "",
  });
  const [priceData, setPriceData] = useState({
    base_price: "",
    loading_charge: "",
    insurance_charge: "",
    quality_charge: "",
    gst: "",
    tcs: "",
    price_validity: "",
    quantity: "",
  });
  const [variationData, setVariationData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [qualityData, setQualityData] = useState([]);
  const [loadWithinData, setLoadWithinData] = useState("");
  const handleUpdateMode = async (mode_type, product) => {
    setUpdateMode(mode_type);

    if (product.id) {
      setproductNameId({
        product_id: product.id,
        product_name: product.name,
      });

      switch (mode_type) {
        case "price":
          try {
            const response = await axios.get(
              `${config.apiUrl}/seller/get-commodity-product-price/${product.id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: config.token,
                  Accept: "application/json",
                },
              }
            );
            
            setPriceData((prevData) => ({
              ...prevData,
              base_price: response.data.data.base_price ?? "",
              loading_charge: response.data.data.loading_charge ?? "",
              insurance_charge: response.data.data.insurance_charge ?? "",
              quality_charge: response.data.data.quality_charge ?? "",
              gst: response.data.data.gst ?? "",
              tcs: response.data.data.tcs ?? "",
              price_validity: response.data.data.price_validity ?? "",
              quantity: response.data.data.quantity ?? "",
            }));
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logout();
            }
          }
          break;

        case "variation":
          try {
            const response = await axios.get(
              `${config.apiUrl}/seller/get-commodity-product-variation/${product.id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: config.token,
                  Accept: "application/json",
                },
              }
            );
            setVariationData(response.data.data ?? "");
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logout();
            }
          }
          break;

        case "stock":
          try {
            const response = await axios.get(
              `${config.apiUrl}/seller/get-commodity-product-variation-stock/${product.id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: config.token,
                  Accept: "application/json",
                },
              }
            );
            setStockData(response.data.data);
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logout();
            }
          }
          break;

        case "quality":
          try {
            const response = await axios.get(
              `${config.apiUrl}/seller/get-commodity-product-quality/${product.id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: config.token,
                  Accept: "application/json",
                },
              }
            );
            // Transform the response data to match the format expected by the component
            const qualityItems = response.data.quality.map((quality, index) => {
              const isSelected = response.data.selected_quality.includes(quality);
              let price = response.data.quality_price[index] || "0";
              
              // If quality is selected, use the selected quality price (user updated price)
              if (isSelected) {
                const selectedIndex = response.data.selected_quality.indexOf(quality);
                if (selectedIndex !== -1 && response.data.selected_quality_price[selectedIndex]) {
                  price = response.data.selected_quality_price[selectedIndex];
                }
              }
              
              return {
                name: quality,
                price: price,
                is_selected: isSelected ? 1 : 0
              };
            });
            setQualityData(qualityItems);
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logout();
            }
          }
          break;

        case "load_within":
          setLoadWithinData(product.load_within || "");
          break;

        default:
          break;
      }
    }
  };
  const handleUpdateDataChange = (e, mode_type, index = null) => {
    switch (mode_type) {
      case "price":
        const { name, value } = e.target;
        setPriceData({
          ...priceData,
          [name]: value,
        });
        break;

      case "variation":
        if (index !== null) {
          const updatedData = [...variationData];
          if (e.target.type === "checkbox") {
            updatedData[index].is_selected =
              updatedData[index].is_selected === 1 ? 0 : 1;
          } else {
            updatedData[index].price = e.target.value;
          }
          setVariationData(updatedData);
        }
        break;

      case "stock":
        if (index !== null) {
          const updatedData = [...stockData];
          updatedData[index].stock = e.target.value;
          setStockData(updatedData);
        }
        break;

      case "quality":
        if (index !== null) {
          const updatedData = [...qualityData];
          if (e.target.type === "checkbox") {
            updatedData[index].is_selected =
              updatedData[index].is_selected === 1 ? 0 : 1;
          } else {
            updatedData[index].price = e.target.value;
          }
          setQualityData(updatedData);
        }
        break;

      case "load_within":
        setLoadWithinData(e.target.value);
        break;

      default:
        break;
    }
  };
  const submitUpdateData = async (e, mode_type) => {
    e.preventDefault();

    if (productNameId.product_id) {
      setLoading1(true);
      try {
        let formData;
        let apiUrl;

        switch (mode_type) {
          case "price":
            apiUrl = `${config.apiUrl}/seller/update-commodity-product-price/${productNameId.product_id}`;
            formData = {
              base_price: priceData.base_price || 0,
              loading_charge: priceData.loading_charge || 0,
              insurance_charge: priceData.insurance_charge || 0,
              quality_charge: priceData.quality_charge || 0,
              gst: priceData.gst || 0,
              tcs: priceData.tcs || 0,
              price_validity: priceData.price_validity || null,
              quantity: priceData.quantity || 0,
            };
            break;

          case "variation":
            const hasError = variationData.some(
              (item) =>
                item.is_selected === 1 && (!item.price || item.price < 0)
            );
            if (hasError) {
              setLoading1(false);
              toast.error("The selected price can not be negative", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              return;
            }
            apiUrl = `${config.apiUrl}/seller/update-commodity-product-variation/${productNameId.product_id}`;
            const variation_id = variationData.map((item) => item.id);
            const is_selected = variationData.map((item) => item.is_selected);
            const variation_price = variationData.map(
              (item) => item.price || "0"
            );
            formData = {
              id: variation_id,
              price: variation_price,
              is_selected: is_selected,
            };
            break;

          case "stock":
            const stockError = stockData.some((item) => !item.stock);
            if (stockError) {
              setLoading1(false);
              toast.error("The selected stock can not be blank", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              return;
            }
            apiUrl = `${config.apiUrl}/seller/update-commodity-product-variation-stock/${productNameId.product_id}`;
            const stock_id = stockData.map((item) => item.id);
            const stock_value = stockData.map((item) => item.stock || "0");
            formData = {
              id: stock_id,
              stock: stock_value,
            };
            break;

          case "quality":
            const qualityError = qualityData.some(
              (item) =>
                item.is_selected === 1 && (!item.price || item.price < 0)
            );
            if (qualityError) {
              setLoading1(false);
              toast.error("The selected quality price can not be negative", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              return;
            }
            apiUrl = `${config.apiUrl}/seller/update-commodity-product-quality/${productNameId.product_id}`;
            // Only send selected qualities and their prices
            const selectedQualities = qualityData.filter(item => item.is_selected === 1);
            const quality_names = selectedQualities.map((item) => item.name);
            const quality_prices = selectedQualities.map((item) => item.price || "0");
            formData = {
              quality: quality_names,
              quality_price: quality_prices,
            };
            break;

          case "load_within":
            apiUrl = `${config.apiUrl}/seller/update-commodity-product-load-within/${productNameId.product_id}`;
            formData = {
              load_within: loadWithinData,
            };
            break;

          default:
            break;
        }

        const response = await axios.post(apiUrl, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        });

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        const closeBtn = document.getElementById("update_close");
        setTimeout(() => {
          resetProductUpdate();
          closeBtn.click();
          dispatch(fetchCommodityProduct());
        }, [1500]);
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setTimeout(() => {
          setLoading1(false);
        }, 2000);
      }
    }
  };
  const resetProductUpdate = () => {
    setUpdateMode(null);
    setproductNameId({
      product_id: "",
      product_name: "",
    });
    setPriceData({
      base_price: "",
      loading_charge: "",
      insurance_charge: "",
      quality_charge: "",
      gst: "",
      tcs: "",
      price_validity: "",
      quantity: "",
    });
    setVariationData([]);
    setStockData([]);
    setQualityData([]);
    setLoadWithinData("");
  };

  //Status Change Function
  const [statusLoading, setStatusLoading] = useState(false);
  const handleStatusChange = async (productId, currentStatus, productName) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    
    // Show SweetAlert2 confirmation dialog
    const result = await Swal.fire({
      title: `${newStatus === 'active' ? 'Activate' : 'Deactivate'} Product`,
      html: `Are you sure you want to <strong>${newStatus === 'active' ? 'activate' : 'deactivate'}</strong> "<em>${productName}</em>"?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: newStatus === 'active' ? '#198754' : '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: `Yes, ${newStatus === 'active' ? 'Activate' : 'Deactivate'}!`,
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      buttonsStyling: true,
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      }
    });

    if (result.isConfirmed) {
      setStatusLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/seller/update-commodity-product-status/${productId}`,
          {
            status: newStatus
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        // Show success alert
        await Swal.fire({
          title: 'Success!',
          text: response.data.message || `Product ${newStatus === 'active' ? 'activated' : 'deactivated'} successfully!`,
          icon: 'success',
          confirmButtonColor: '#198754',
          confirmButtonText: 'OK',
          timer: 3000,
          timerProgressBar: true,
          buttonsStyling: true,
          customClass: {
            confirmButton: 'swal2-success-custom'
          }
        });

        // Refresh the product list to show updated status
        dispatch(fetchCommodityProduct(logout));

      } catch (error) {
        // Show error alert
        await Swal.fire({
          title: 'Error!',
          text: error.response?.data?.message || "Failed to update product status",
          icon: 'error',
          confirmButtonColor: '#dc3545',
          confirmButtonText: 'OK',
          buttonsStyling: true,
          customClass: {
            confirmButton: 'swal2-error-custom'
          }
        });
        
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setStatusLoading(false);
      }
    }
  };  
  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {dataLoading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={productimg} alt="" />
                    <h5>
                      {mode === "add"
                        ? "Add Product"
                        : mode === "show"
                        ? "Product Detail"
                        : "My Products"}
                    </h5>
                  </div>
                  {mode === "add" || mode === "show" ? (
                    <button
                      type="button"
                      className="add-edit-btn"
                      onClick={() => handleMode("list")}
                    >
                      <i className="bi bi-x-lg"></i>Cancel
                    </button>
                  ) : (
                    hasPermission('product', 'create') && (
                      <button
                        type="button"
                        className="add-edit-btn"
                        onClick={() => handleMode("add")}
                      >
                        <i className="bi bi-plus-lg"></i>Add New
                      </button>
                    )
                  )}
                </div>
                <p className="order-note">
                  <span>Note - </span>
                  {mode === "add"
                    ? "Please select the options in this order: Product Category, Commodity Product, Product Brand, State, and finally City. This will help us assist you more effectively."
                    : "Feel free to explore our wide range of products! You can select from various brands, Category and more. Choose the right variation and start selling."}
                </p>

                {mode === "add" ? (
                  <div className="px-lg-4 py-4 border-top rounded-2">
                    <form onSubmit={submitProduct}>
                      <div className="row g-3">
                        <div className="col-lg-3 px-2">
                          <label className="form-label" htmlFor="category">
                            Product Category
                          </label>
                          <select
                            className="form-control"
                            name="category"
                            id="category"
                            onChange={categoryChange}
                          >
                            <option value="">Select category</option>
                            {categoryData.map((category) => {
                              return (
                                <option value={category.id} key={category.id}>
                                  {category.name}
                                </option>
                              );
                            })}
                          </select>
                          {formError.categoryError && (
                            <span className="input-error">
                              {formError.categoryError}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-3 px-2">
                          <label className="form-label" htmlFor="product">
                            Commodity Product List
                          </label>
                          <select
                            className="form-control"
                            name="product"
                            id="product"
                            onChange={productChange}
                          >
                            <option value="">Select product</option>
                            {productList.map((product) => {
                              return (
                                <option value={product.id} key={product.id}>
                                  {product.name}
                                </option>
                              );
                            })}
                          </select>
                          {formError.productError && (
                            <span className="input-error">
                              {formError.productError}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-3 px-2">
                          <label className="form-label" htmlFor="brand">
                            Product Brand
                          </label>
                          <select
                            className="form-control"
                            name="brand"
                            id="brand"
                            onChange={brandChange}
                          >
                            <option value="">Select brand</option>
                            {brandList.map((brand) => {
                              return (
                                <option value={brand.id} key={brand.id}>
                                  {brand.name}
                                </option>
                              );
                            })}
                          </select>
                          {formError.brandError && (
                            <span className="input-error">
                              {formError.brandError}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-3 px-2">
                          <label className="form-label" htmlFor="state">
                            State
                          </label>
                          <select
                            className="form-control"
                            name="state"
                            id="state"
                            onChange={stateChange}
                          >
                            <option value="">Select state</option>
                            {stateList.map((state, index) => {
                              return (
                                <option value={state} key={index}>
                                  {state}
                                </option>
                              );
                            })}
                          </select>
                          {formError.stateError && (
                            <span className="input-error">
                              {formError.stateError}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-3 px-2">
                          <label className="form-label" htmlFor="city">
                            City
                          </label>
                          <select
                            className="form-control"
                            name="city"
                            id="city"
                            onChange={cityChange}
                          >
                            <option value="">Select city</option>
                            {cityList.map((city, index) => {
                              return (
                                <option value={city} key={index}>
                                  {city}
                                </option>
                              );
                            })}
                          </select>
                          {formError.cityError && (
                            <span className="input-error">
                              {formError.cityError}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-12 text-end">
                          <button
                            type="submit"
                            className="submit_btn"
                            disabled={loading}
                          >
                            <i className="bi bi-floppy"></i>
                            {loading ? "Submitting" : "Submit"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                ) : mode === "show" ? (
                  <div className="commodity_detail px-lg-4 rounded-2">
                    <div className="row g-3">
                      <div className="col-lg-5 col-md-5">
                        <div className="image_side">
                          <ul className="image_list">
                            {productDetail.images
                              .slice(0, 4)
                              .map((image, index) => (
                                <li
                                  onMouseEnter={() => handleImageClick(image)}
                                  key={index}
                                >
                                  <img
                                    src={image}
                                    onError={imageOnError}
                                    className="img-fluid"
                                    alt="product"
                                  />
                                </li>
                              ))}
                          </ul>
                          <div className="preview">
                            <img
                              src={selectedImage}
                              className="img-fluid"
                              alt="product"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-7">
                        <div className="row product_aside">
                          <div className="col-lg-12">
                            <h1 className="name">{productDetail.name}</h1>
                            <p className="desc">{productDetail.description}</p>
                          </div>
                          <div className="col-lg-12">
                            <h2 className="heading">Product Details</h2>
                          </div>
                          <div className="col-lg-4">
                            <table className="detail">
                              <tbody>
                                <tr>
                                  <td>Base Price</td>
                                  <td>
                                    <span>
                                      <i className="bi bi-currency-rupee"></i>
                                      <NumberFormatter
                                        number={productDetail.base_price}
                                      />
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loading Charge</td>
                                  <td>
                                    <span>
                                      <i className="bi bi-currency-rupee"></i>
                                      <NumberFormatter
                                        number={productDetail.loading_charge}
                                      />
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-lg-4">
                            <table className="detail">
                              <tbody>
                                <tr>
                                  <td>Category</td>
                                  <td>
                                    <span> {productDetail.category.name}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Sub Category</td>
                                  <td>
                                    <span>
                                      {productDetail.sub_category.name}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-lg-4">
                            <table className="detail">
                              <tbody>
                                <tr>
                                  <td>Brand</td>
                                  <td>
                                    <span>{productDetail.brands.name}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Unit</td>
                                  <td>
                                    <span>{productDetail.unit.name}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-lg-4">
                            <h2 className="heading">Packaging</h2>
                            <table className="detail">
                              <tbody>
                                {productDetail.packaging.map((pkg, index) => (
                                  <tr key={index}>
                                    <td>{pkg.name}</td>
                                    <td>
                                      <span>
                                        Rs{" "}
                                        <NumberFormatter number={pkg.price} />
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          {productDetail.loading_address.map(
                            (address, index) => (
                              <div className="col-lg-6" key={index}>
                                <h2 className="heading">
                                  Loading Address{index + 1}
                                </h2>
                                <table className="detail">
                                  <tbody>
                                    <tr>
                                      <td>Address line1</td>
                                      <td>
                                        <span>{address.address_line_one}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Address line2</td>
                                      <td>
                                        <span>{address.address_line_two}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Pincode</td>
                                      <td>
                                        <span>{address.pincode}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {commodityProductData.length > 0 ? (
                      <div className="row g-3">
                        {commodityProductData.map((product, index) => {
                          return (
                            <div className="col-lg-6 col-md-6 px-2" key={index}>
                              <div className={`order-product ${product.status === 'inactive' ? 'bg-light opacity-75 border-2 border-warning' : 'border border-success'}`}>
                                <div className="row py-2 align-items-center">
                                  <div className="col-3">
                                    <div className="order-image">
                                      <img
                                        src={product.thumbnail}
                                        onError={imageOnError}
                                        alt={product.name}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-9 ps-0">
                                    <div className="order-detail">
                                      <h6 className="one-line-clamp d-flex align-items-center">
                                        <span>{product.name}</span>
                                        <span className={`ms-2 badge ${product.status === 'active' ? 'bg-success' : 'bg-secondary'} rounded-pill text-capitalize text-white`}>
                                          <i className={`bi ${product.status === 'active' ? 'bi-check-circle' : 'bi-pause-circle'} me-1`}></i>
                                          {product.status}
                                        </span>
                                      </h6>
                                      <div className="order-tag">
                                        <div>
                                          <span className="f-500">
                                            Base Price:
                                          </span>
                                          <span>
                                            Rs&nbsp;
                                            <NumberFormatter
                                              number={product.base_price}
                                            />
                                          </span>
                                        </div>
                                        <div>
                                          <span className="f-500">Brand:</span>
                                          <span>{product.brands.name}</span>
                                        </div>
                                        <div>
                                          <span className="f-500">
                                            Category:
                                          </span>
                                          <span>{product.category.name}</span>
                                        </div>
                                        
                                        {/* <div>
                                          <span className="f-500">
                                            Sub Category:
                                          </span>
                                          <span>
                                            {product.sub_category.name}
                                          </span>
                                        </div>
                                        <div>
                                          <span className="f-500">
                                            Loading Charge:
                                          </span>
                                          <span>
                                            Rs{" "}
                                            <NumberFormatter
                                              number={product.loading_charge}
                                            />
                                          </span>
                                        </div> */}
                                        <div>
                                          <span className="f-500">
                                            Price Validity:
                                          </span>
                                          <span>
                                            {product.price_validity}
                                          </span>
                                        </div>
                                        <div>
                                          <span className="f-500">
                                            Quantity:
                                          </span>
                                          <span>
                                            {product.quantity}
                                          </span>
                                        </div>
                                        <div>
                                          <span className="f-500">
                                            Dispatch Within:
                                          </span>
                                          <span>{product.load_within} Days</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row order-product-btn">
                                  <div className="col-lg-12 px-0 text-center">
                                    <button
                                      type="button"
                                      className="ord-btn invc"
                                      onClick={() =>
                                        handleMode("show", product)
                                      }
                                      title="Product Detail"
                                    >
                                      <i className="bi bi-basket2 me-1"></i>
                                      Product Details
                                    </button>
                                  </div>
                                </div>
                                <div className="abs_menu">
                                  <div className="dropdown">
                                    <button
                                      className="drop-btn"
                                      id={`dropMenuButton-${product.id}`}
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul
                                      className="dropdown-menu"
                                      aria-labelledby={`dropMenuButton-${product.id}`}
                                    >
                                      <li>
                                        {hasPermission('product', 'edit') && (
                                          <button
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#productupdate"
                                            onClick={() =>
                                              handleUpdateMode("price", product)
                                            }
                                          >
                                            <i className="bi bi-tags me-2"></i>
                                            Price
                                          </button>
                                        )}
                                      </li>
                                      <li>
                                        {hasPermission('product', 'edit') && (
                                          <button
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#productupdate"
                                            onClick={() =>
                                              handleUpdateMode("variation", product)
                                            }
                                          >
                                            <i className="bi bi-sliders2-vertical me-2"></i>
                                            Variation
                                          </button>
                                        )}
                                      </li>
                                      <li>
                                        {hasPermission('product', 'edit') && (
                                          <button
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#productupdate"
                                            onClick={() =>
                                              handleUpdateMode("quality", product)
                                            }
                                          >
                                            <i className="bi bi-cart-check me-2"></i>
                                            Quality
                                          </button>
                                        )}
                                      </li>
                                      <li>
                                        {hasPermission('product', 'edit') && (
                                          <button
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#productupdate"
                                            onClick={() =>
                                              handleUpdateMode("stock", product)
                                            }
                                          >
                                            <i className="bi bi-shop me-2"></i>
                                            Stock
                                          </button>
                                        )}
                                      </li>
                                      <li>
                                        {hasPermission('product', 'edit') && (
                                          <button
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#productupdate"
                                            onClick={() =>
                                              handleUpdateMode("load_within", product)
                                            }
                                          >
                                            <i className="bi bi-truck me-2"></i>
                                            Dispatch Within
                                          </button>
                                        )}
                                      </li>
                                      <li><hr className="dropdown-divider" /></li>
                                      <li>
                                        {hasPermission('product', 'status') && (
                                          <button
                                            className="dropdown-item"
                                            onClick={() =>
                                              handleStatusChange(
                                                product.id,
                                                product.status,
                                                product.name
                                              )
                                            }
                                            disabled={statusLoading}
                                          >
                                            {product.status === 'active' ? (
                                              <>
                                                <i className="bi bi-toggle-off me-2 text-danger"></i>
                                                {statusLoading ? 'Deactivating...' : 'Deactivate'}
                                              </>
                                            ) : (
                                              <>
                                                <i className="bi bi-toggle-on me-2 text-success"></i>
                                                {statusLoading ? 'Activating...' : 'Activate'}
                                              </>
                                            )}
                                          </button>
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <NoData />
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/**Product price variation stock Form */}
      <div
        className="modal fade"
        id="productupdate"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="productupdateLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
          <div className="modal-content custom-modal">
            <div className="header">
              <h5 className="title">
                {updateMode === "price"
                  ? "Update Price"
                  : updateMode === "variation"
                  ? "Update Variation"
                  : updateMode === "quality"
                  ? "Update Quality"
                  : updateMode === "load_within"
                  ? "Update Dispatch Within"
                  : "Update Stock"}
                &nbsp;&nbsp;-&nbsp;&nbsp;{productNameId.product_name}
              </h5>
              <button
                type="button"
                className="custom-btn bg-warning rounded-2 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="update_close"
                onClick={resetProductUpdate}
              >
                Cancel
              </button>
            </div>
            <div className="body">
              {updateMode === "price" ? (
                <form onSubmit={(e) => submitUpdateData(e, "price")}>
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="base_price">
                        Base Price
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="base_price"
                        id="base_price"
                        value={priceData.base_price}
                        placeholder="Enter Price"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="price_validity">
                        Price Validity
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="price_validity"
                        id="price_validity"
                        value={priceData.price_validity}
                        placeholder="Enter Price"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="quantity">
                        Quantity
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="quantity"
                        id="quantity"
                        value={priceData.quantity}
                        placeholder="Enter Quantity"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="loading_charge">
                        Loading Charge
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="loading_charge"
                        id="loading_charge"
                        value={priceData.loading_charge}
                        placeholder="Enter Loading Price"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="insurance_charge">
                        Insurance Charge
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="insurance_charge"
                        id="insurance_charge"
                        value={priceData.insurance_charge}
                        placeholder="Enter Insurance Price"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="quality_charge">
                        Quality Charge
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="quality_charge"
                        id="quality_charge"
                        value={priceData.quality_charge}
                        placeholder="Enter Quality Charge"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="gst">
                        GST Charge (%)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="gst"
                        id="gst"
                        value={priceData.gst}
                        placeholder="Enter GST Charge"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="tcs">
                        TCS Charge (%)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="tcs"
                        id="tcs"
                        value={priceData.tcs}
                        placeholder="Enter TCS Charge"
                        onChange={(e) => handleUpdateDataChange(e, "price")}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    <div className="col-lg-12 mt-2 text-end">
                      <button
                        type="submit"
                        className="custom-btn bg-success rounded-2 ms-2"
                        disabled={loading1}
                      >
                        {loading1 ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              ) : updateMode === "variation" ? (
                <form onSubmit={(e) => submitUpdateData(e, "variation")}>
                  <div className="row g-3">
                    <div className="col-lg-12">
                      <p className="mb-0 text-success">
                        Select the variant you want to update the price.
                      </p>
                    </div>
                    <div className="col-lg-12">
                      <div className="table-responsive">
                        <table className="chart-table table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Action</th>
                              <th>Requirements</th>
                              <th>Guage Difference</th>
                            </tr>
                          </thead>
                          <tbody>
                            {variationData.length > 0 ? (
                              variationData.map((variation, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="fw-normal">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input custom_check"
                                          type="checkbox"
                                          checked={variation.is_selected === 1}
                                          onChange={(e) =>
                                            handleUpdateDataChange(
                                              e,
                                              "variation",
                                              index
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td className="bg-light">
                                      {variation.value[0].value}
                                      {variation.value[0].unit.short_name}
                                    </td>
                                    <td>
                                      {variation.is_selected === 1 ? (
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={variation.price}
                                          onChange={(e) =>
                                            handleUpdateDataChange(
                                              e,
                                              "variation",
                                              index
                                            )
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          disabled={variation.is_selected === 0}
                                          required
                                        />
                                      ) : (
                                        "Not Applicable"
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  className="fw-normal text-center"
                                  colSpan="3"
                                >
                                  No Data Found....
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-12 mt-2 text-end">
                      <button
                        type="submit"
                        className="custom-btn bg-success rounded-2 ms-2 mb-1"
                        disabled={loading1}
                      >
                        {loading1 ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              ) : updateMode === "quality" ? (
                <form onSubmit={(e) => submitUpdateData(e, "quality")}>
                  <div className="row g-3">
                    <div className="col-lg-12">
                      <p className="mb-0 text-success">
                        Select the quality you want to update the price.
                      </p>
                    </div>
                    <div className="col-lg-12">
                      <div className="table-responsive">
                        <table className="chart-table table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Action</th>
                              <th>Quality</th>
                              <th>Price Difference</th>
                            </tr>
                          </thead>
                          <tbody>
                            {qualityData.length > 0 ? (
                              qualityData.map((quality, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="fw-normal">
                                      <div className="form-check">
                                        <input
                                          className="form-check-input custom_check"
                                          type="checkbox"
                                          checked={quality.is_selected === 1}
                                          onChange={(e) =>
                                            handleUpdateDataChange(
                                              e,
                                              "quality",
                                              index
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td className="bg-light">
                                      {quality.name}
                                    </td>
                                    <td>
                                      {quality.is_selected === 1 ? (
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={quality.price}
                                          onChange={(e) =>
                                            handleUpdateDataChange(
                                              e,
                                              "quality",
                                              index
                                            )
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          disabled={quality.is_selected === 0}
                                          required
                                        />
                                      ) : (
                                        "Not Applicable"
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  className="fw-normal text-center"
                                  colSpan="3"
                                >
                                  No Data Found....
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-12 mt-2 text-end">
                      <button
                        type="submit"
                        className="custom-btn bg-success rounded-2 ms-2 mb-1"
                        disabled={loading1}
                      >
                        {loading1 ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              ) : updateMode === "load_within" ? (
                <form onSubmit={(e) => submitUpdateData(e, "load_within")}>
                  <div className="row g-3">
                    <div className="col-lg-12">
                      <p className="mb-0 text-success">
                        Update the Dispatch Within value for this product.
                      </p>
                    </div>
                    <div className="col-lg-12">
                      <label className="form-label" htmlFor="load_within">
                        Dispatch Within (Days)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="load_within"
                        id="load_within"
                        value={loadWithinData}
                        placeholder="Enter Dispatch Within (Days)"
                        onChange={(e) => handleUpdateDataChange(e, "load_within")}
                        required
                      />
                    </div>
                    <div className="col-lg-12 mt-2 text-end">
                      <button
                        type="submit"
                        className="custom-btn bg-success rounded-2 ms-2 mb-1"
                        disabled={loading1}
                      >
                        {loading1 ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              ) : (
                <form onSubmit={(e) => submitUpdateData(e, "stock")}>
                  <div className="row g-3">
                    <div className="col-lg-12">
                      <p className="mb-0 text-success">
                        You can change the value of only selected stocks.
                      </p>
                    </div>
                    <div className="col-lg-12">
                      <div className="table-responsive">
                        <table className="chart-table table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Action</th>
                              <th>Requirements</th>
                              <th>Stock</th>
                            </tr>
                          </thead>
                          <tbody>
                            {stockData.length > 0 ? (
                              stockData.map((stock, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="fw-normal">
                                      {stock.is_selected === 1 ? (
                                        <span className="text-success fw-bold">
                                          Selected
                                        </span>
                                      ) : (
                                        <span className="text-danger fw-bold">
                                          Not Selected
                                        </span>
                                      )}
                                    </td>
                                    <td className="bg-light">
                                      {stock.value[0].name} -
                                      {stock.value[0].value}
                                    </td>
                                    <td>
                                      {stock.is_selected === 1 ? (
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={stock.stock}
                                          onChange={(e) =>
                                            handleUpdateDataChange(
                                              e,
                                              "stock",
                                              index
                                            )
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          disabled={stock.is_selected === 0}
                                          required
                                        />
                                      ) : (
                                        "Not Applicable"
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  className="fw-normal text-center"
                                  colSpan="3"
                                >
                                  No Data Found....
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-lg-12 mt-2 text-end">
                      <button
                        type="submit"
                        className="custom-btn bg-success rounded-2 ms-2 mb-1"
                        disabled={loading1}
                      >
                        {loading1 ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      {/**End product Form */}
    </>
  );
}
